<img
  [ngClass]="logo_class"
  [src]="logo_src" />
